import { Pipe, PipeTransform } from '@angular/core';
import { formatDuration } from '../../utils/time-utils';

@Pipe({
  name: 'time',
  standalone: true,
})
export class TimePipe implements PipeTransform {
  transform(duration: number, format = '{h} h {min}'): string {
    return formatDuration(duration, format);
  }
}
